module.exports = __webpack_public_path__ + "static/img/2.1b83f47b.png";